module.exports = __webpack_public_path__ + "assets/img/center_icon05.1eae7612.svg";